<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd" style="margin-top:20px">上传凭证</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src="item.FILE_URL" class="image" style="height:200px" v-if="item.FILE_TYPE === 1">
          <img :src="pdfImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else-if="item.FILE_TYPE === 2">
          <img :src="wordImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else-if="item.FILE_TYPE === 3">
          <img :src="unknowImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <el-button size="small" type="text" class="button" @click="openImage(item.FILE_URL)" v-if="item.FILE_TYPE === 1">查看大图</el-button>
              <el-button size="small" type="text" class="button" @click="downLoad(item.FILE_URL)" v-else>下载</el-button>
              <el-button size="small" type="text" class="button" style="float:right" @click="deleteImg(item.ID)">删除
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-row>
      <el-col>
        <el-dialog :visible.sync="addFormDialog" title="上传资质凭证" @close="close" width="400px" center>
          <el-form ref="addForm" v-model="addForm">
            <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove" :on-success="handleSuccess"
              :name="this.addForm.image" :multiple="false" :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form>
          <div slot="footer" style="text-align: center;">
            <el-button size="small" class="operate-btn" @click="close">取消</el-button>
            <el-button size="small" class="operate-btn" @click="submitAdd">确认</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      addFormDialog: false,
      addForm: {
        image: 'SupplierQualify',
      },
      fileList: [],
      url: '',
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('@/assets/images/pdf.png'),
      wordImage: require('@/assets/images/word.png'),
      unknowImage: require('@/assets/images/unknow.png'),
    };
  },
  methods: {
    // -----------------------------------------进入页面拉取数据
    queryContract() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 12,
        ORDER_ID: this.$route.params.id,
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
        } else {
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -----------------------------------删除订单资质
    deleteImg(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10002',
            OTYPE: 11,
            FILE_ID: row,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryContract();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    openAdd() {
      this.addFormDialog = true;
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = e;
    },
    downLoad(e) {
      window.location.href = e;
    },
    handleSuccess(response, file, fileList) {
      this.url = response.base_url + response.file_name;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    close() {
      this.addFormDialog = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // -----------------------------------------添加订单资质
    submitAdd() {
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10002',
            OTYPE: 10,
            ORDER_ID: this.$route.params.id,
            FILE_URL: this.url,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.queryContract();
            this.close();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
  created() {
    this.queryContract();
  },
};
</script>
<style>
.image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_historyContantract.vue